{
  "campaignName": "Noon Points",
  "platform": "Noon",
  "description": "Points for providing liquidity.",
  "platformImageId": "noon-points.png",
  "dashboardLink": "https://app.noon.capital/rewards/",
  "pools": [
    {
      "id": "null",
      "action": "lp",
      "description": "280x Noon points per USN deposited.",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x24894F0c4f80837d61CA21730A75Fa216FED7200",
      "network": "tac",
      "multiplier": "280x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x1436e4Ca2c687335b7c5E1b446AE532b9e287160",
      "network": "tac",
      "multiplier": "180x",
      "tags": ["points"],
      "lock": "false"
    }
  ]
}
